<template>
  <div class="mobile-menu__search" :class="{ 'show-close-button': query }">
    <SearchForm
      location="Mobile menu"
      show-pending
      ref="form"
      v-model="query"
      @pane-open="onPaneOpen"
    />
  </div>
</template>

<script>
  import SearchForm from "Plugins/elasticsearch-autocomplete/javascript/components/searchbar/SearchForm.vue";

  export default {
    components: {
      SearchForm,
    },

    data() {
      return {
        query: "",
      };
    },

    emits: ["active"],

    methods: {
      /** Empties the field, which closes the result sheet. */
      clear() {
        this.$refs.form?.clearSearchField();
      },

      // Relayed rather than derived from the query: the sheet is what covers the
      // menu, and it opens on a pending search and stays up for an empty one.
      onPaneOpen(isOpen) {
        this.$emit("active", isOpen);
      },
    },

    name: "MobileMenuSearch",
  };
</script>
